// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelForm-ErrorMessage_cls1__I1XGy","cls2":"PaymentChannelForm-ErrorMessage_cls2__fuxl3 PaymentChannelForm-ErrorMessage_cls1__I1XGy"};